module.exports = __webpack_public_path__ + "static/d10dbbb7-5c52-4d71-b9e2-408af63a518f-7470d7938619c1485d696f58f6c38ea9.webp";